import React,{useState,useEffect} from 'react';
import { ThemeContext,themes} from '../Contexts/Theme';
export default function ThemeContextWrapper(props)
{
    const [theme,setTheme] = useState(themes.dark);
    const abc = document.getElementById("homeCard");
    function changeTheme(theme)
    {
        setTheme(theme);
    }
    useEffect(()=>
    {
        switch(theme)
        {
            case themes.light:
                document.body.style.backgroundColor = "#171717";
                if(abc)
                {
                    abc.style.backgroundColor="#D3D3D3";
                    document.getElementById("hey").style.color="whitesmoke";
                    document.getElementById("navbar").style.backgroundColor="black";
                }
                break;
            case themes.dark:
            default:
                document.body.style.backgroundColor = "#e4e4e4";
                if(abc)
                {
                document.getElementById("homeCard").style.backgroundColor="whitesmoke";
                document.getElementById("hey").style.color="black";
          
                document.getElementById("navbar").style.backgroundColor="#A9A9A9";
                }
                
                break;
        }
    },[theme]);
    return(
        <ThemeContext.Provider value={{theme:theme,changeTheme:changeTheme}}>
            {props.children}
        </ThemeContext.Provider>
    );
}